import { render, staticRenderFns } from "./char2.vue?vue&type=template&id=06c78f04&"
import script from "./char2.vue?vue&type=script&lang=js&"
export * from "./char2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports